import { View } from "../base";

export interface TabDefinition {
  id: string;
  label: string;
  color: "indigo" | "amber" | "gray" | "blue" | "emerald" | "purple";
}

interface SpanDetailTabsProps {
  tabs: TabDefinition[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const colorClasses: Record<TabDefinition["color"], { active: string; inactive: string }> = {
  indigo: {
    active: "border-indigo-500 text-indigo-600 dark:text-indigo-400",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
  amber: {
    active: "border-amber-500 text-amber-600 dark:text-amber-400",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
  gray: {
    active: "border-gray-500 text-gray-600 dark:text-gray-300",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
  blue: {
    active: "border-blue-500 text-blue-600 dark:text-blue-400",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
  emerald: {
    active: "border-emerald-500 text-emerald-600 dark:text-emerald-400",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
  purple: {
    active: "border-purple-500 text-purple-600 dark:text-purple-400",
    inactive: "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300",
  },
};

export const SpanDetailTabs = ({ tabs, activeTab, onTabChange }: SpanDetailTabsProps) => {
  return (
    <View className="flex flex-row border-b border-gray-200 dark:border-gray-700 px-4">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const colors = colorClasses[tab.color];
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${isActive ? colors.active : colors.inactive}`}
          >
            {tab.label}
          </button>
        );
      })}
    </View>
  );
};
